import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';

import AiChatAgentPage from '@/pages/features/AiChatAgentPage';
import KnowledgeBasePage from '@/pages/features/KnowledgeBasePage';
import LeadCapturePage from '@/pages/features/LeadCapturePage';
import FaqAutomationPage from '@/pages/features/FaqAutomationPage';
import SupportAutomationPage from '@/pages/features/SupportAutomationPage';
import TrialSupportPage from '@/pages/features/TrialSupportPage';

import PrivacyPolicyPage from '@/pages/legal/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/legal/TermsOfServicePage';
import CookiePolicyPage from '@/pages/legal/CookiePolicyPage';
import GdprPage from '@/pages/legal/GdprPage';
import SecurityPage from '@/pages/legal/SecurityPage';

import ContactPage from '@/pages/ContactPage';
import AboutPage from '@/pages/AboutPage';
import CareersPage from '@/pages/CareersPage';

import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        {/* Feature Pages */}
        <Route path="/features/ai-chat-agent" element={<AiChatAgentPage />} />
        <Route path="/features/knowledge-base" element={<KnowledgeBasePage />} />
        <Route path="/features/lead-capture" element={<LeadCapturePage />} />
        <Route path="/features/faq-automation" element={<FaqAutomationPage />} />
        <Route path="/features/support-automation" element={<SupportAutomationPage />} />
        <Route path="/features/trial-support" element={<TrialSupportPage />} />

        {/* Company Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/gdpr" element={<GdprPage />} />
        <Route path="/security" element={<SecurityPage />} />
      </Routes>
      <Toaster position="top-right" richColors theme="dark" />
    </BrowserRouter>
  );
}

export default App;
